// extracted by mini-css-extract-plugin
export default {"tips_container":"E9","tips_title":"F9","tip_str_container":"G9","tip_str":"H9","tip_carousel":"I9","tips_desktop_container":"J9","tips_margin_container_mob":"K9"};
    if(module.hot) {
      // 1738836199008
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  